<template>
  <div class="busi4-page busi-detail">
    <section class="banner">
      <h1>智能产品服务</h1>
      <p>
        智能产品板块，是衔接公司上下游链条服务的重要一环，且嵌入九恒的生态链条之中，更具市场竞争力。目前，为提升行业能源利用效率，降低运营成本，解决高比例新能源接入和消纳重要环节，智能制造业务已结合智能配电、智能用电、智能巡检等应用领域，推出综合性解决方案和电力系统智能产品。
        <a href="https://www.wjx.cn/vm/t9gPiBR.aspx#" target="_blank">立即咨询</a>
      </p>
    </section>
    <ul class="img ctn">
      <li>
        <img src="@/assets/b4-2.jpg"/>
        <h3>智能储、充解决方案</h3>
        <ol>
          <li>储能技术</li>
          <li>超级快充</li>
        </ol>
      </li>
      <li>
        <img src="@/assets/b4-3.jpg"/>
        <h3>智能配电解决方案</h3>
        <ol>
          <li>柔性直流技术</li>
          <li>绿色环保智能开关</li>
        </ol>
      </li>
      <li>
        <img src="@/assets/b4-4.jpg"/>
        <h3>智能用电解决方案</h3>
        <ol>
          <li>智能电网载波通信芯片</li>
        </ol>
      </li>
    </ul>
    <h2>两大基地，助力智造发展</h2>
    <p>多年来，公司持续布局电能智造领域，并已规划北京与张家口两大产业基地，促进电力智能产品的研发与生产。 </p>
    <ul class="img2 ctn">
      <li>
        <img src="@/assets/b4-5.jpg"/>
        <h3>北京亦庄·智能研发+高端制造基地</h3>
        <p>亦庄经济开发区是具有全球影响力的创新产业集群和科技服务中心，亦是制造业转型升级示范区及战略性新兴产业基地。九恒亦庄基地占地25亩，计划2024年投入使用，将作为九恒的智能研发基地，促进电力智能产品的开发与生产。</p>
      </li>
      <li>
        <img src="@/assets/b4-6.jpg"/>
        <h3>张家口怀来·智能制造基地</h3>
        <p>怀来制造基地位于新能源名城怀来，借助张家口地区的自然清洁能源优势，九恒计划将该基地作为九恒智能产品的实验与生产中心，预计3年内投产。</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  }
}
</script>
